"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeConfigurationV1Utils = void 0;
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
const echain_shared_configurations_oo_1 = require("@igus/echain-shared-configurations-oo");
const ConfigurationJsonToExchangeConfigurationV1Transformer_1 = require("./ConfigurationJsonToExchangeConfigurationV1Transformer");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
class ExchangeConfigurationV1Utils {
    static create({ appName, configurationJson, staticArticleDataDict, }) {
        return this._create({
            appName,
            configurationJson,
            staticArticleDataDict,
            creationOptions: {
                migrateConfiguration: true,
                updateArticlesAndRemoveUnknown: true,
            },
        });
    }
    /**
     * This will just transform the given configuration.
     * Take care: This will NOT migrate NOR update the articles!!
     */
    static transform(configurationJson, appName) {
        return this._create({
            appName,
            configurationJson,
            staticArticleDataDict: undefined,
            creationOptions: {
                migrateConfiguration: false,
                updateArticlesAndRemoveUnknown: false,
            },
        });
    }
    static _create({ appName, configurationJson, staticArticleDataDict = echain_shared_articles_1.ArticlesDictUtils.create(), creationOptions: { migrateConfiguration, updateArticlesAndRemoveUnknown }, }) {
        // 1. migrate to newest DomainVersion
        const migratedConfigurationJson = migrateConfiguration
            ? echain_shared_configurations_oo_1.Configuration.fromJson(configurationJson).toJson()
            : configurationJson;
        // 2. update articles with newest static data and remove unknown
        const updatedConfiguration = updateArticlesAndRemoveUnknown
            ? echain_shared_configurations_1.ConfigurationJsonUpdater.updateOrRemoveArticles({
                staticArticleDataDict,
                configurationJson: migratedConfigurationJson,
            }).updatedConfiguration
            : migratedConfigurationJson;
        // 3. fix configuration to be consistent
        const validConfiguration = echain_shared_configurations_oo_1.ConfigurationJsonSanitizer.transformToValidConfiguration(updatedConfiguration);
        // 4. populate removed articles
        const removedArticles = updateArticlesAndRemoveUnknown
            ? echain_shared_configurations_1.ConfigurationJsonUpdater.getRemovedArticles({
                originalConfigurationJson: configurationJson,
                updatedConfigurationJson: validConfiguration,
            })
            : echain_shared_articles_1.ArticlesDictUtils.create();
        // 5. transform to exchange format
        const exchangeConfiguration = ConfigurationJsonToExchangeConfigurationV1Transformer_1.ConfigurationJsonToExchangeConfigurationV1Transformer.transform({
            appName,
            configurationJson: validConfiguration,
            removedArticles,
        });
        return exchangeConfiguration;
    }
}
exports.ExchangeConfigurationV1Utils = ExchangeConfigurationV1Utils;
//# sourceMappingURL=ExchangeConfigurationV1Utils.js.map